// history.js
// 假定route的meta里包含keepAlive和componentName属性
const formRecord = (vueRoute) => {
  return {
    name: vueRoute.name,
    path: vueRoute.fullPath,
    keepAlive: vueRoute.meta && vueRoute.meta.keepAlive
  }
}

export default {
  namespaced: true,
  state: {
    records: [], // 历史路由数组
    index: 0, // 当前路由索引
    direction: '' // history变化方向, forward/backward
  },
  getters: {
    routes: state => {
      const { records, index } = state
      if (records.length > 0 && index < records.length) {
        return records.slice(0, index + 1)
      }
      return []
    },
    historyIndex: state => state.index
  },
  mutations: {
    // 记录 router.push
    PUSH_ROUTE(state, vueRoute) {
      const record = formRecord(vueRoute)
      // eslint-disable-next-line prefer-const
      let { records, index } = state
      if (index + 1 < records.length) {
        records = records.slice(0, index + 1)
      }
      records.push(record)
      state.records = records
      state.index = records.length - 1
      state.direction = 'forward'
    },
    // 记录 router.replace
    REPLACE_ROUTE(state, vueRoute) {
      const record = formRecord(vueRoute)
      // eslint-disable-next-line prefer-const
      let { records, index } = state
      const isRecordIndex = records.findIndex(item => item.name === record.name)
      if (isRecordIndex >= 0) {
        records.splice(isRecordIndex, records.length)
      }
      if (index + 1 < records.length) {
        records = records.slice(0, index + 1)
      }
      records.pop()
      records.push(record)
      state.records = records
      state.index = records.length - 1
      state.direction = 'forward'
    },
    // 记录 router.pop 前进/后退
    // count是跳跃的历史记录数, >0是前进, <0是回退，path是当前的location.href
    POP_ROUTE(state, { count, path }) {
      // eslint-disable-next-line prefer-const
      let { records, index, direction } = state
      if (count) {
        direction = count > 0 ? 'forward' : 'backward'
        index += count
        index = Math.min(records.length, index)
        index = Math.max(0, index)
      } else {
        console.log(index, count, path, records)
        if (index > 0 && records[index - 1].path === path) {
          // 后退
          direction = 'backward'
          index -= 1
        } else if (index < records.length - 1 && records[index + 1].path === path) {
          // 前进
          direction = 'forward'
          index += 1
        }
      }

      state.records = records
      state.index = index
      state.direction = direction
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/model/history.js